import angular from 'angular';

let verticalMenu = angular
    .module("verticalMenu", []);

export default verticalMenu;